import { Helmet } from 'react-helmet';

const Learning = () => {
  return (
    <>
      <Helmet>
        <title>Learning Centre in Damoh | Shrikant Tally Institute – Find Us</title>
        <meta name="description" content="Find Shrikant Tally Institute at Purana Thana, near SBI ATM, Damoh, MP 470661. Get directions, contact details and locate our Tally learning centre in Damoh." />
        <meta name="keywords" content="Tally learning centre Damoh, Shrikant Tally Institute location, Tally institute near me, accounting institute Damoh address, Purana Thana Damoh, Tally Education centre Damoh, Tally course near Damoh, find Tally institute MP" />
        <meta property="og:title" content="Learning Centre in Damoh | Shrikant Tally Institute" />
        <meta property="og:description" content="Located at Purana Thana, near SBI ATM, Damoh MP. Get directions to Shrikant Tally Institute and start your Tally certification journey." />
        <meta property="og:url" content="https://shrikanttallyinstitute.com/learning" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://shrikanttallyinstitute.com/learning" />
      </Helmet>
      <style>{`
        .lc-hero {
          background: linear-gradient(135deg, #4d3d6c 0%, #6b4f9e 60%, #90b732 100%);
          padding: 64px 24px;
          color: #fff;
          position: relative;
          overflow: hidden;
        }
        .lc-hero::before {
          content: '';
          position: absolute;
          top: -80px; right: -80px;
          width: 300px; height: 300px;
          background: rgba(144,183,50,0.15);
          border-radius: 50%;
        }
        .lc-hero h1 { font-size: clamp(1.8rem, 4vw, 2.6rem); font-weight: 800; }
        .lc-hero p  { font-size: 15px; opacity: 0.85; max-width: 520px; }
        .lc-hero-badge {
          display: inline-block;
          background: rgba(255,255,255,0.15);
          border: 1px solid rgba(255,255,255,0.3);
          border-radius: 50px;
          padding: 4px 16px;
          font-size: 12.5px;
          margin-bottom: 14px;
        }
        .lc-hero img {
          max-height: 280px;
          filter: drop-shadow(0 8px 24px rgba(0,0,0,0.2));
          animation: lcFloat 4s ease-in-out infinite;
        }
        @keyframes lcFloat {
          0%,100% { transform: translateY(0); }
          50%      { transform: translateY(-10px); }
        }

        .lc-map-section { background: #f2f8f6; padding: 64px 24px; }
        .lc-map-wrap {
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 8px 32px rgba(77,61,108,0.12);
          border: 2px solid #e8f5c8;
        }
        .lc-search-box .form-control,
        .lc-search-box .form-select {
          border-color: #90b732;
          font-size: 13.5px;
          border-radius: 8px;
        }
        .lc-search-box .form-control:focus,
        .lc-search-box .form-select:focus {
          box-shadow: 0 0 0 3px rgba(144,183,50,0.15);
          border-color: #90b732;
        }
        .lc-info-card {
          background: #fff;
          border-radius: 14px;
          padding: 20px;
          border: 1.5px solid #e8f5c8;
          display: flex;
          align-items: flex-start;
          gap: 14px;
          transition: box-shadow 0.2s;
        }
        .lc-info-card:hover { box-shadow: 0 6px 20px rgba(144,183,50,0.12); }
        .lc-info-icon {
          width: 42px; height: 42px;
          background: #ecf3d7;
          border-radius: 10px;
          display: flex; align-items: center; justify-content: center;
          font-size: 18px;
          flex-shrink: 0;
        }
        .lc-info-card h6 { font-size: 13px; font-weight: 700; color: #4d3d6c; margin-bottom: 3px; }
        .lc-info-card p  { font-size: 12.5px; color: #777; margin: 0; line-height: 1.6; }
        .lc-dir-btn {
          background: #90b732;
          color: #fff;
          font-weight: 700;
          border: none;
          border-radius: 8px;
          padding: 11px 24px;
          font-size: 14px;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          transition: transform 0.2s, box-shadow 0.2s;
        }
        .lc-dir-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(144,183,50,0.35);
          color: #fff;
        }
      `}</style>

      {/* ── Hero ── */}
      <div className="lc-hero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-7 mb-4 mb-md-0">
              <span className="lc-hero-badge">📍 Damoh, Madhya Pradesh</span>
              <h1>Learning Centre in Damoh</h1>
              <p className="mt-3">
                We are conveniently located near Purana Thana, Damoh. Start your career path with Tally certification and expert support — all near you.
              </p>
            </div>
            <div className="col-md-5 text-center d-none d-md-block">
              <img
                src="https://tallyeducation.com/tepl/wp-content/themes/TEPL/assets/images/learningbanner.png"
                className="img-fluid"
                alt="Learning Banner"
              />
            </div>
          </div>
        </div>
      </div>

      {/* ── Map + Search ── */}
      <div className="lc-map-section">
        <div className="container">
          <div className="row align-items-start g-5">

            {/* Left — search + info */}
            <div className="col-md-5">
              <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', color: '#90b732', marginBottom: 8 }}>Find Us</p>
              <h2 className="fw-bold mb-2" style={{ color: '#4d3d6c' }}>Locate Our Centre</h2>
              <p className="text-muted mb-4" style={{ fontSize: 14, lineHeight: 1.8 }}>
                Search by location, center name, or pincode to find us easily.
              </p>

              {/* Search */}
              <div className="lc-search-box d-flex flex-column flex-sm-row gap-2 mb-4">
                <select className="form-select" style={{ maxWidth: 160 }}>
                  <option>Damoh</option>
                  <option>Location</option>
                  <option>Center Name</option>
                </select>
                <div className="input-group">
                  <input type="text" className="form-control" defaultValue="Purana Thana, Damoh" placeholder="Enter location or pincode" />
                  <a
                    href="https://www.google.com/maps/dir//Shrikant+tally+institute,+asati+ward+no.1,+Purana+Thana+Rd,+near+sbi+atm,+Damoh,+Madhya+Pradesh+470661"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn"
                    style={{ background: '#90b732' }}
                  >
                    <i className="bi bi-search text-white"></i>
                  </a>
                </div>
              </div>

              {/* Info cards */}
              <div className="d-flex flex-column gap-3 mb-4">
                <div className="lc-info-card">
                  <div className="lc-info-icon">📍</div>
                  <div>
                    <h6>Address</h6>
                    <p>Asati Ward No.1, Purana Thana Rd,<br />Near SBI ATM, Damoh, MP 470661</p>
                  </div>
                </div>
                <div className="lc-info-card">
                  <div className="lc-info-icon">📞</div>
                  <div>
                    <h6>Phone</h6>
                    <p>9131385180</p>
                  </div>
                </div>
                <div className="lc-info-card">
                  <div className="lc-info-icon">🕐</div>
                  <div>
                    <h6>Working Hours</h6>
                    <p>Mon – Sat: 8:00 AM – 8:00 PM</p>
                  </div>
                </div>
                <div className="lc-info-card">
                  <div className="lc-info-icon">✉️</div>
                  <div>
                    <h6>Email</h6>
                    <p>shrikanttallyinstitute@gmail.com</p>
                  </div>
                </div>
              </div>

              <a
                href="https://www.google.com/maps/dir//Shrikant+tally+institute,+asati+ward+no.1,+Purana+Thana+Rd,+near+sbi+atm,+Damoh,+Madhya+Pradesh+470661"
                target="_blank"
                rel="noopener noreferrer"
                className="lc-dir-btn"
              >
                <i className="bi bi-map-fill"></i> Get Directions
              </a>
            </div>

            {/* Right — map */}
            <div className="col-md-7">
              <div className="lc-map-wrap">
                <iframe
                  title="Shrikant Tally Institute Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3651.902!2d79.4422!3d23.8360!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39820114bb86174d%3A0xed2dd93d2c2e70b5!2sShrikant%20Tally%20Institute!5e0!3m2!1sen!2sin!4v1234567890"
                  width="100%"
                  height="480"
                  style={{ border: 0, display: 'block' }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Learning;
